import React from 'react'
import { useState } from 'react'
import type { Translation } from '../../i18n'
import { serif, warm900, warm500, stone, cream, textMuted } from './tokens'

const FaqItem: React.FC<{ q: string; a: string }> = ({ q, a }) => {
  const [open, setOpen] = useState(false)
  return (
    <div
      className="rounded-[2px] overflow-hidden cursor-pointer"
      style={{ border: `1px solid ${stone}` }}
      onClick={() => setOpen(o => !o)}
    >
      <div
        className="flex justify-between items-center px-6 py-4 transition-colors"
        style={{ background: open ? '#fdf8f2' : '#fff' }}
      >
        <span className="font-semibold text-[1.05rem] pr-4" style={{ fontFamily: serif, color: warm900 }}>{q}</span>
        <span
          className="text-[1.3rem] font-light leading-none min-w-[20px] text-center transition-transform duration-300 shrink-0"
          style={{ color: warm500, transform: open ? 'rotate(45deg)' : 'none' }}
        >+</span>
      </div>
      {open && (
        <div className="px-6 py-4" style={{ borderTop: `1px solid ${stone}`, background: '#fdf8f2' }}>
          <p className="text-[0.9rem] leading-[1.8]" style={{ color: textMuted }}>{a}</p>
        </div>
      )}
    </div>
  )
}

type Props = { l: Translation['landing']['faq'] }

export const FaqSection: React.FC<Props> = ({ l }) => (
  <section id="faq" className="px-10 md:px-20 py-24" style={{ background: cream }}>
    <div className="max-w-[760px] mx-auto">
      <p className="flex items-center gap-3 text-[0.75rem] font-medium tracking-[0.18em] uppercase mb-4" style={{ color: warm500 }}>
        <span className="w-6 h-px inline-block" style={{ background: warm500 }} />
        {l.sectionLabel}
      </p>
      <h2
        className="text-[clamp(2rem,3.5vw,3rem)] font-light leading-[1.15] mb-8"
        style={{ fontFamily: serif, color: warm900 }}
      >
        {l.title}
      </h2>
      <div className="flex flex-col gap-3">
        {l.items.map((item, i) => (
          <FaqItem key={i} q={item.q} a={item.a} />
        ))}
      </div>
    </div>
  </section>
)
